import { createSlice } from "@reduxjs/toolkit";

import { ReduxReducer } from "../../../../interface";
import { Reports } from "../../interface";

import { State } from "./interface";

const initialState: State = {
	unitedData: [],
	dividedData: [],
};

const setReportsData: ReduxReducer<State, State> = (state, action) => {
	state.unitedData = action.payload.unitedData;
	state.dividedData = action.payload.dividedData;
};

const reportCashlessOrdersData = createSlice({
	name: Reports.ConstantReportSlice.CASHLESS_ORDERS,
	initialState,
	reducers: {
		setReportsData,
	},
});

export const reportCashlessOrdersDataAction = reportCashlessOrdersData.actions;
export const reportCashlessOrdersDataReducer = reportCashlessOrdersData.reducer;
export type reportCashlessOrdersDataState = State;

export default reportCashlessOrdersData;
